import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Styles } from "../styles/carousel.style.js"

export default function Carousel({ isEvent, children }) {
  const slider = React.useRef(null)
  const settings = {
    centerMode: true,
    centerPadding: isEvent ? "0px" : "11px",
    infinite: false,
    autoplay: false,
    arrows: false,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  }

  return (
    <div>
      <div>
        <Styles isEvent={isEvent}>
          <div className="carousel-container">
            <Slider ref={slider} {...settings} className="carousel">
              {children}
            </Slider>
          </div>
        </Styles>
      </div>
    </div>
  )
}
